import { ROUTE_PERMISSIONS } from '@shared/permissions';
import { PermissionGuard } from '@shared/router';
import { Route } from 'react-router';

import { NotificationListingPage } from './pages/NotificationListingPage';
import { notificationsPath } from './urls';

export const NotificationRoutes = (
  <>
    <Route
      path={notificationsPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.notifications}>
          <NotificationListingPage />
        </PermissionGuard>
      }
    />
  </>
);

export default NotificationRoutes;
